import {get, post} from "./helper_api"
import * as url from "./helper_path"

const getPolicieAPI = params => get(url.GET_POLICIE.concat('/').concat(params)).catch(err => err);

const getPoliciesAPI = params => get(url.GET_POLICIES,params).catch(err => err);

export {
    getPolicieAPI,getPoliciesAPI
}
